import DefaultAvatarSvg from '@/../assets/icons/default-avatar.svg';

interface DefaultAvatarProps {
  readonly size?: number;
}

export const DefaultAvatar = ({ size = 48 }: DefaultAvatarProps) => (
  <DefaultAvatarSvg width={size} height={size} />
);
